import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { loginUser } from '../../redux/actions/auth';





const Login =(props)=> {
    const initData = {
        pre_heading: "Login",
        heading: "Login to your Account",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis deleniti asperiores sit."
    }

    const [state, setState] = useState({
        email: '',
        password: '',
      })
    
      const doLogin = (e) => {
        e.preventDefault();
        props.dispatch(loginUser({ password: state.password, email: state.email },props.history)).then(res=>{
          if (res) {
            props.history.go(0)
          }else{
            alert('Invalid email or password')
          }
        })
      }
    
      const changeCreds = (event) => {
        setState({ ...state, [event.target.name]: event.target.value })
      }
    
      const { from } = props.location.state || { from: { pathname: '/' }};
      if (JSON.parse(localStorage.getItem('authenticated'))) {
        return (
          <Redirect to={from} />
        )
      }
        return (
            <section className="author-area">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-7">
                            {/* Intro */}
                            <div className="intro text-center">
                                <span>{initData.pre_heading}</span>
                                <h3 className="mt-3 mb-0">{initData.heading}</h3>
                                <p>{initData.content}</p>
                            </div>
                            {/* Item Form */}
                            <form className="item-form card no-hover" onSubmit={(event) => doLogin(event)}>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input onChange={(event) => changeCreds(event)} type="email" className="form-control" name="email" placeholder="Enter your Email" required="required" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input onChange={(event) => changeCreds(event)} type="password" className="form-control" name="password" placeholder="Enter your Password" required="required" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" defaultValue="option1" defaultChecked />
                                                <label className="form-check-label" htmlFor="inlineRadio1">Remember Me</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <button className="btn w-100 mt-3 mt-sm-4" type="submit">Sign In</button>
                                    </div>
                                    
                                </div>
                            </form>

                            {/* <div className='mt-2'>
                                <p>Don't have account? <span><Link to={'/signup'}>Sign Up</Link></span></p>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
        );
    
}

function mapStateToProps(state) {
    return {
      
      isAuthenticated: state.auth.isAuthenticated,
      
    };
  }
  
  export default withRouter(connect(mapStateToProps)(Login));